<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="ErpId"
      label="ERP ID"
      type="text"
      v-model="formData.ErpId"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Identificador del sistema ERP"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="ObjetoId"
      label="Objeto ID"
      type="number"
      v-model="formData.ObjetoId"
      :required="true"
      helpText="ID del objeto en el sistema"
    />
    
    <FormField
      id="CampoGestion360"
      label="Campo Gestión 360"
      type="text"
      v-model="formData.CampoGestion360"
      :required="true"
      :maxlength="128"
      :disabled="isEditing"
      helpText="Campo en el sistema Gestión 360"
    />
    
    <FormField
      id="CampoErp"
      label="Campo ERP"
      type="text"
      v-model="formData.CampoErp"
      :maxlength="128"
      helpText="Campo correspondiente en el sistema ERP"
    />
    
    <FormField
      id="Transformacion"
      label="Transformación"
      type="textarea"
      v-model="formData.Transformacion"
      :maxlength="500"
      helpText="Reglas de transformación de datos"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatMapeoErpForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    mapeoErp: {
      type: Object,
      default: () => ({
        ErpId: '',
        EmpresaId: 1,
        ObjetoId: null,
        CampoGestion360: '',
        CampoErp: '',
        Transformacion: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.mapeoErp }
    };
  },
  watch: {
    mapeoErp: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
